import React from 'react';
import styles from './InternationalForay.module.css';

const InternationalForay = () => {
    return (
        <section className={styles.foraySection}>
            <div className={styles.container}>
                <div className={styles.forayContent}>
                    {/* Text Content */}
                    <div className={styles.textContent}>
                        {/* <div className={styles.labelContainer}>
                            <span className={styles.forayLabel}></span>
                        </div> */}

                        <div className={styles.titleContainer}>
                            <h2 className={styles.forayTitle}>
                                Core <span className={styles.bluelabel}>Expertise</span>
                            </h2>
                        </div>

                        <div className={styles.descriptionContainer}>
                            <ul> 
                                <li className={styles.forayDescription}>EHV GIS & AIS Substations (400 kV, 220 kV, 132 kV, 33 kV)</li> 
                                <li className={styles.forayDescription}>Power Transmission & Distribution Systems (HT/LT)</li> 
                                <li className={styles.forayDescription}>Underground Cable Projects (up to 220kV)</li> 
                                <li className={styles.forayDescription}>Industrial Electrification</li> 
                                <li className={styles.forayDescription}>Tunnel Ventilation & SCADA Systems</li> 
                                <li className={styles.forayDescription}>Fire Fighting Systems for Railways/Metros</li> 
                                <li className={styles.forayDescription}>Turnkey EPC Projects</li> 
                            </ul>
                            <p >
                            </p>
                        </div>
                    </div>

                    {/* Image Content */}
                    <div className={styles.imageContent}>
                        <div className={styles.imageContainer}>
                            <img
                                src="/images/core.jpg"
                                alt="Saudi Arabia Skyline - Riyadh"
                                className={styles.cityImage}
                            />
                            {/* Orange accent bar */}
                            <div className={styles.blueAccent}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InternationalForay;
